<i class="icon icon-arrow-{{ isUp ? 'up rate-up' : 'down rate-down'}} ic-{{ isPositive ? 'success' : 'error'}}"></i>
